import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

import { makeBusyFunction } from "lib/@components/busy/make-busy-function"

const IMPORT_LEGACY_CUSTOM_SCHEDULES = gql`
    mutation ImportLegacyCustomSchedules($subscriptionId: Int!, $selectedIds: [Int!]!) {
        importLegacyCustomSchedules(subscriptionId: $subscriptionId, selectedIds: $selectedIds) {
            imported
            skipped
            alreadyRunning
        }
    }
`

export const importLegacyCustomSchedules = makeBusyFunction(
    api(function importLegacyCustomSchedules(subscriptionId, selectedIds) {
        return mutate(
            IMPORT_LEGACY_CUSTOM_SCHEDULES,
            { subscriptionId, selectedIds },
            { returns: "importLegacyCustomSchedules" }
        )
    }),
    "Import Legacy Custom Schedules"
)
